<template>
  <div class="bell-container position-relative d-inline-block">
    <button class="btn btn-link position-relative p-1" @click="toggleDropdown" title="Alertas de Pendências">
      <i class="bi bi-bell fs-5"></i>
      <!-- Badge vermelho: NOVAS (não visualizadas) -->
      <span v-if="novas > 0" class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style="font-size: 0.6rem;">
        {{ novas > 99 ? '99+' : novas }}
      </span>
      <!-- Badge amarelo: TOTAL (pendências ativas) -->
      <span v-if="total > 0" class="position-absolute top-100 start-100 translate-middle badge rounded-pill bg-warning text-dark" style="font-size: 0.55rem;">
        {{ total > 99 ? '99+' : total }}
      </span>
    </button>

    <Teleport to="body">
      <div v-if="showDropdown" class="dropdown-pendencias shadow" :style="dropdownStyle">
        <div class="dropdown-header d-flex justify-content-between align-items-center px-3 py-2 border-bottom">
          <strong class="small">Pendências <span v-if="total > 0">({{ total }})</span></strong>
          <button class="btn btn-sm btn-link text-secondary p-0" @click="showDropdown = false">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        <div class="dropdown-body">
          <div v-if="alertas.length === 0" class="text-center text-muted py-4">
            <i class="bi bi-check-circle fs-4 d-block mb-1"></i>
            <span class="small">Nenhuma pendência</span>
          </div>
          <div v-for="alerta in alertas" :key="alerta.idAlertaPendencia"
               class="alerta-item px-3 py-2 border-bottom" role="button"
               :class="{ 'alerta-nao-visto': !alerta.eVisto }"
               @click="navegar(alerta, $event)">
            <strong class="small d-block" :class="{ 'fw-bold': !alerta.eVisto }">{{ alerta.titulo }}</strong>
            <p class="small text-muted mb-1">{{ alerta.mensagem }}</p>
            <small class="text-secondary">{{ formatarTempo(alerta.tsCriacao) }}</small>
          </div>
        </div>
        <div v-if="alertas.length > 0" class="dropdown-footer text-center border-top py-1">
          <button class="btn btn-sm btn-link text-primary" @click="marcarTodosLidos">
            Marcar todos como lidos
          </button>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import api from '@/services/api'
import { usePendenciasStore } from '@/stores/pendencias'
import { mapState } from 'pinia'
import { useNavegacao } from '@/composables/useNavegacao'
import { reservarZIndex, liberarZIndex, BASE_ZINDEX } from '@/composables/useZIndex'

export default {
  name: 'BellPendencias',
  data () {
    return {
      alertas: [],
      showDropdown: false,
      pollingInterval: null,
      // --- Empilhamento (z-index) via registry central ---
      zIndexDropdown: BASE_ZINDEX,
      tokenZIndex: null
    }
  },
  computed: {
    ...mapState(usePendenciasStore, ['total', 'novas']),
    dropdownStyle () {
      return {
        position: 'fixed',
        top: '56px',
        right: '60px',
        width: '360px',
        maxHeight: '400px',
        zIndex: this.zIndexDropdown,
        backgroundColor: 'var(--bs-body-bg)',
        borderRadius: '0.5rem',
        overflow: 'hidden'
      }
    }
  },
  watch: {
    showDropdown (aberto) {
      if (aberto) {
        const { token, zIndex } = reservarZIndex()
        this.tokenZIndex = token
        this.zIndexDropdown = zIndex
      } else {
        liberarZIndex(this.tokenZIndex)
        this.tokenZIndex = null
      }
    }
  },
  mounted () {
    usePendenciasStore().atualizarContagem()
    this.pollingInterval = setInterval(() => {
      usePendenciasStore().atualizarContagem()
    }, 30000)
  },
  beforeUnmount () {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval)
    }
    liberarZIndex(this.tokenZIndex)
    this.tokenZIndex = null
  },
  methods: {
    async toggleDropdown () {
      this.showDropdown = !this.showDropdown
      if (this.showDropdown) {
        await this.carregarAlertas()
      }
    },
    async carregarAlertas () {
      try {
        const { data } = await api.get('/AlertasPendencia', { params: { limite: 20 } })
        this.alertas = data || []
      } catch (e) {
        this.alertas = []
      }
    },
    async navegar (alerta, evento) {
      this.showDropdown = false
      try {
        await api.patch(`/AlertasPendencia/${alerta.idAlertaPendencia}/visualizar`)
        usePendenciasStore().atualizarContagem()
      } catch (e) { /* silencia */ }

      let destino = null
      try { destino = JSON.parse(alerta.rotaFrontend || '{}') } catch (e) { destino = null }
      if (!destino || !destino.modulo) return

      // NOVA ABA (Ctrl+Clique / Cmd+Clique / botão do meio) — padrão sessionStorage do sistema
      if (evento?.ctrlKey || evento?.metaKey || evento?.button === 1) {
        useNavegacao().abrirComSession('pendenciasDestino', destino)
        return
      }

      // MESMA ABA — emite evento para o Dashboard navegar
      this.$emit('navegar-pendencia', destino)
    },
    async marcarTodosLidos () {
      try {
        await api.patch('/AlertasPendencia/visualizar-todos')
        this.novas = 0
        this.alertas.forEach(a => { a.eVisto = true })
        this.showDropdown = false
      } catch (e) { /* silencia */ }
    },
    formatarTempo (ts) {
      if (!ts) return ''
      const data = new Date(ts)
      const agora = new Date()
      const diffMs = agora - data
      const diffMin = Math.floor(diffMs / 60000)
      if (diffMin < 1) return 'Agora'
      if (diffMin < 60) return `${diffMin} min atrás`
      const diffHr = Math.floor(diffMin / 60)
      if (diffHr < 24) return `${diffHr}h atrás`
      return data.toLocaleDateString('pt-BR')
    }
  }
}
</script>

<style scoped>
.bell-container .btn-link {
  color: var(--bs-navbar-color, rgba(255,255,255,0.85));
  text-decoration: none;
}
.bell-container .btn-link:hover {
  color: var(--bs-navbar-hover-color, rgba(255,255,255,1));
}
.alerta-item {
  cursor: pointer;
  transition: background-color 0.15s;
}
.alerta-item:hover {
  background-color: var(--bs-tertiary-bg);
}
.alerta-item p {
  margin-bottom: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.alerta-nao-visto {
  border-left: 3px solid #0d6efd !important;
  background-color: rgba(13, 110, 253, 0.04);
}
</style>
